import React, { Component } from "react";
import parse from 'html-react-parser';
import {getFavoriteTopics,articlebytaxonomy,sectionlist} from '../config/Variables';
import {baseurl} from '../config/Settings';
export default class FetchFavoriteSections extends Component {

  constructor() {
    super();
    this.state = {
      hobbies: [],
      tid: '',
      sectionid: '',
      sectiontids: '',
      sectionslist:[],
      messagelog: '',
      isLoading: true,
      users: [],
      sectionlabels: [],
      numberstid: [],
      error: null,
      lengthusers: 111110
    }   
    this.getFetchNewsletterpamap = this.getFetchNewsletterpamap.bind(this);
    this.getFetchSectionsLabel = this.getFetchSectionsLabel.bind(this);
    
    this.getFetchNewsletter = this.getFetchNewsletter.bind(this);
    
  }

   getFetchSectionsLabel() {

var sectionstring='';
    let user = JSON.parse(localStorage.getItem('user-info'))
         let datt = fetch(getFavoriteTopics, {
           method: 'POST',
           headers: {
             "Content-Type": "application/json",
             "Accept": 'application/json',
             "Authorization": "Bearer " + user.token.access_token,
           },
           body: JSON.stringify(this.state)
         }).then(response => response.json())
           .then(data => {
            if(data.webmsg.code==401){
              localStorage.clear();
              var domainurl=  window.location.origin;
              window.location.href = domainurl+'/journey';
            }
             data.data.map(({ tid }, index2) => {
              sectionstring =tid + '+' + sectionstring ;
              // this.state.numberstid.push(tid);
               //this.setState({ numberstid: [this.state.numberstid, tid] })
           
               this.state.sectionslist.push(tid);
               
             });
             var ss=this.state.sectionslist.join('+');

             if(ss ===""){
              ss="none";
            }
             this.setState({
              loading: true
            }, () => {
              fetch(sectionlist+ss).then(res => res.json()).then(result => this.setState({
                loading: false,
                sectionlabels: result,
                sectionid: ss
              })).catch(console.log);
            });
           });
           
           //var ss=this.state.sectionslist.join('+');
           
         

   }

 
  getFetchNewsletterpamap(event) {

    const target = event.target;
    var value = target.value;


   
    //console.log(this.props);
 
  
    var urllink=articlebytaxonomy+value;
   
    this.setState({
        loading: true
    }, () => {
        fetch(urllink).then(res => res.json()).then(result => this.setState({
            loading: false,
            users: result,
            sectiontids: value
        })).catch(console.log);
    });
}



    getFetchNewsletter(nextProps) {
    
 //   console.log(this.props);

 var vv=this.state.sectionid;

const x=444444;
if(this.props.parameters==null){
   x=0;
}
  this.setState({ sectiontids:  this.props.parameters,lengthusers: x })
  
    //var urllink="https://aawsat.com/" + this.props.url;
    var urllink=baseurl + nextProps.url;
   
    this.setState({
        loading: true
    }, () => {
        fetch(urllink).then(res => res.json()).then(result => this.setState({
            loading: false,
            users: result,
            sectiontids:  this.props.parameters
        })).catch(console.log);
    });
}
componentDidMount() {
  this.getFetchSectionsLabel();
  this.getFetchNewsletter(this.props);
    
    
    setTimeout(() => {
     // var script = document.createElement('script'); script.type = 'text/javascript'; script.src = 'https://aawsat.com/themes/custom/aawsatv3/assets/js/app.js?fev='; document.head.appendChild(script);
   }, 3000);

  
}
runAfterRender = () => 
{
  const myElem = document.getElementById("myElem")
  if(myElem)
  {
    //do important stuff
  }
}

render() {
  const {
    users,
    error,
    loading,
    sectionlabels,
    sectiontids,
    lengthusers
  } = this.state;

  if(lengthusers ==111110){
    return(
      <>
      {loading ? <div className="loading-mypage">   <img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?ssss"/></div>: ""}
      </>
      );
  } if(lengthusers ==0  && loading==true){
    return (
    <div className="cell small-12 large-9 c-tab-content_js tab-active" data-id="myTags">
    <div className="content-wrap vertical-scroll"> 
        <div className="section-wrapper">
            <div className="section-title style-v2 show-for-large">
                <h3><span><a href="#">مواضيعي</a></span></h3>
                <div className="more"><a href="#"><i className="icomoon-icon icon-arrow-left hide"></i></a></div>
            </div>
            <div className="section-content"> 
    <div class="category-content">
                                                   <div class="empty-content">
                                                      <div class="empty-content-img">
                                                          <img src={`${baseurl}themes/custom/aawsatv3/assets/img/icon/search.svg`} alt="search"/>
                                                      </div>
                                                      <div class="empty-content-text">
                                                          لا يوجد لديك اقسام مفضلة
                                                      </div>
                                                      <div class="emtpty-content-button">
                                                          <button data-id="modal-tags" class="modal-toggle button primary rounded">اختر مواضيعك المفضلة</button>
                                                      </div>
                                                   </div>
                                              </div>
                                              </div>
                                              </div>
                                              </div>
                                              </div>);
  }else{

  return (
 
                <div className="cell small-12 large-9 c-tab-content_js tab-active" data-id="myTags">
                    <div className="content-wrap vertical-scroll"> 
                        <div className="section-wrapper">
                            <div className="section-title style-v2 show-for-large">
                                <h3><span><a href="#">مواضيعي</a></span></h3>
                                <div className="more"><a href="#"><i className="icomoon-icon icon-arrow-left hide"></i></a></div>
                            </div>
                            <div className="section-content"> 
                            <div className="category-menu">
                            <div className="category-menu-add"> 
                                                    <div className="add-more small round modal-toggle" data-id="modal-tags">
                                                        <i className="icomoon-icon icon-plus-green"></i>  
                                                    </div>
                                                </div>
                                                <div className="category-menu-tags">
                            <ul className="category-tags cat_js">
                         
                            <li>
                                          <button value={this.props.parameters}  data-value={this.props.parameters} className={sectiontids==this.props.parameters  ? 'button active' : 'button'} onClick={this.getFetchNewsletterpamap} > الكل</button>

                                          </li>
                                <React.Fragment>
                                {
                                    sectionlabels.map(({ name, tid }, index) => {
                                        return (
                                        <li>
                                          <button value={tid} className={tid==sectiontids ? 'button active' : 'button'} onClick={this.getFetchNewsletterpamap} > {name}</button>

                                          </li>
                                        );

                                    
                                    })
                                }
                                </React.Fragment>
                                </ul>
                </div>
                </div>
                                <div className="category-content">
                                    <div className="grid-x grid-margin-x articles-list small-up-1 medium-up-3">
                                   
                                    {loading ? <div className="cell loading-mypage" > <img src="https://aawsat.com/themes/custom/aawsatv3/assets-react/img/loading-new.gif?s" /></div> : 
                                      <React.Fragment>
                                      {
                                        users.map(({ rendered_entity }, index) => {
                                      
                                            return (
                                              <>
                                                {parse(rendered_entity)}
                                                </>
                                            );
                                        })
                                      }
                                    </React.Fragment>   

                                    }

                                    </div> 
                                </div>
                            </div>
                        </div> 
                    </div>
                   
                </div>
                


   

            
           
  );
                                  }
                                    }


  
}
